var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinentEuropeCountryspain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.9999C24 18.7072 23.719 19.3854 23.219 19.8855C22.7189 20.3856 22.0406 20.6666 21.3333 20.6666H2.66667C1.95942 20.6666 1.28115 20.3856 0.781049 19.8855C0.280952 19.3854 0 18.7072 0 17.9999V5.99992C0 5.29267 0.280952 4.6144 0.781049 4.1143C1.28115 3.6142 1.95942 3.33325 2.66667 3.33325H21.3333C22.0406 3.33325 22.7189 3.6142 23.219 4.1143C23.719 4.6144 24 5.29267 24 5.99992V17.9999Z",
    fill: "#C60A1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H24V16H0V8Z",
    fill: "#FFC400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3333V13.3333C6 13.8637 6.21071 14.3724 6.58579 14.7475C6.96086 15.1225 7.46957 15.3333 8 15.3333C8.53043 15.3333 9.03914 15.1225 9.41421 14.7475C9.78929 14.3724 10 13.8637 10 13.3333V11.3333H6Z",
    fill: "#EA596E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667H10V12.6667H8V10.6667Z",
    fill: "#F4A2B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.6667H8V12.6667H6V10.6667Z",
    fill: "#DD2E44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667C9.10457 10.6667 10 10.219 10 9.66675C10 9.11446 9.10457 8.66675 8 8.66675C6.89543 8.66675 6 9.11446 6 9.66675C6 10.219 6.89543 10.6667 8 10.6667Z",
    fill: "#EA596E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.66675C9.10457 9.66675 10 9.44289 10 9.16675C10 8.89061 9.10457 8.66675 8 8.66675C6.89543 8.66675 6 8.89061 6 9.16675C6 9.44289 6.89543 9.66675 8 9.66675Z",
    fill: "#FFAC33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 10.6667H5.33464V15.3334H4.66797V10.6667ZM10.668 10.6667H11.3346V15.3334H10.668V10.6667Z",
    fill: "#99AAB5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.6667H6V15.3333H4V14.6667ZM10 14.6667H12V15.3333H10V14.6667ZM4.66667 10H5.33333V10.6667H4.66667V10ZM10.6667 10H11.3333V10.6667H10.6667V10Z",
    fill: "#66757F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinentEuropeCountryspain);
export default __webpack_public_path__ + "static/media/Continent=Europe, Country=spain.48cd292eaa2e3e956e73c834894f8ba0.svg";
export { ForwardRef as ReactComponent };